import { cn } from '@dz-web/esboot-browser';
import { Modal } from 'antd-mobile';

import IconClose from '../images/close-icon.svg';
import iconError from '../images/icon-message-box-error.png';
import iconSuccess from '../images/icon-message-box-success.png';

import styles from './modal-message-box.scss';

export enum ModalMessageBoxType {
  SUCCESS,
  ERROR,
}

export function useModalMessageBox() {
  const showMessageBox = (content: string, type: ModalMessageBoxType = ModalMessageBoxType.ERROR) => {
    const modal = Modal.show({
      bodyClassName: cn(styles['modal-body'], {
        [styles['error-body']]: type === ModalMessageBoxType.ERROR,
      }),
      content: (
        <div>
          <img src={type === ModalMessageBoxType.SUCCESS ? iconSuccess : iconError} styleName="icon" alt="" />
          <div styleName="close-icon-container" onClick={() => modal.close()}>
            <IconClose styleName="close-icon" />
          </div>
          <div styleName="content">{content}</div>
        </div>
      ),
      closeOnMaskClick: true,
    });
  };

  return {
    showMessageBox,
  };
}
